import { composeIO } from 'react-compose-io'
import { configuracoesGeraisIO } from './ConfiguracoesGerais.IO'
import { ConfiguracoesGeraisView } from './ConfiguracoesGerais.View'

export const ConfiguracoesGerais = composeIO(ConfiguracoesGeraisView, configuracoesGeraisIO)
